import { render } from "./PostStatsModal.vue?vue&type=template&id=52bb5add&scoped=true"
import script from "./PostStatsModal.vue?vue&type=script&lang=js"
export * from "./PostStatsModal.vue?vue&type=script&lang=js"

import "./post-stats-modal.scss?vue&type=style&index=0&id=52bb5add&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52bb5add"]])

export default __exports__